/* The organization rides in the hash rather than the query: many lists spread
   every search param into their filters and API calls, and the hash is read
   by nothing else in the app. */
const ORG_HASH_PREFIX = '#org=';
const OBJECT_ID = /^[a-f\d]{24}$/i;

export const isOrgScopedPath = () =>
  window.location.pathname.startsWith('/app');

export const readOrgFromUrl = (): string | null => {
  const { hash } = window.location;
  if (!isOrgScopedPath() || !hash.startsWith(ORG_HASH_PREFIX)) {
    return null;
  }
  const orgId = hash.slice(ORG_HASH_PREFIX.length);
  return OBJECT_ID.test(orgId) ? orgId : null;
};

/* Written past the router on purpose: nothing reads the hash through it, and
   a navigation here would re-render every route for a change no one sees. */
export const writeOrgToUrl = (orgId: string) => {
  if (!isOrgScopedPath() || readOrgFromUrl() === orgId) {
    return;
  }
  const { pathname, search } = window.location;
  window.history.replaceState(
    window.history.state,
    '',
    `${pathname}${search}${ORG_HASH_PREFIX}${orgId}`,
  );
};
